import { render, staticRenderFns } from "./VTableFoot.vue?vue&type=template&id=d44d0192&"
import script from "./VTableFoot.vue?vue&type=script&lang=js&"
export * from "./VTableFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports